<template>
  <div id="app">
    <router-view/>
    <FloatingStack />
    <CookieConsent />
    <PagePopups/>
  </div>
</template>

  <!-- The core Firebase JS SDK is always required and must be listed first -->
<script src="/__/firebase/8.2.5/firebase-app.js"></script>

<!-- TODO: Add SDKs for Firebase products that you want to use
      https://firebase.google.com/docs/web/setup#available-libraries -->
<script src="/__/firebase/8.2.5/firebase-analytics.js"></script>
<!-- Initialize Firebase -->
<script src="/__/firebase/init.js"></script>
<script>
import NavBar from "@/components/NavBar.vue";
import PagePopups from "@/components/Popups.vue";
import CookieConsent from "@/components/CookieConsent.vue";
import FloatingStack from "@/components/FloatingStack.vue";

export default {
  name: 'App',
  components: {
    NavBar,
    PagePopups,
    CookieConsent,
    FloatingStack,
  },
  created() {
    this.$store.dispatch('regionConfig/init');
    this.$store.dispatch("theme/detectSubdomain");
    // Check if user needs to re-login due to update
    this.$store.dispatch("checkForUpdate");
  },
}
</script>

<style>
/* body {
  font-family: Poppins, sans-serif;
} */
.btn-warning {
  background-color: #ffb600;
  border-color: #ffb600;
  color: #ffffff;
}
.btn-warning:hover,
.btn-outline-warning:hover {
  color: #ffffff;
  background-color: #ffb600;
  border-color: #ffb600;
}
.btn-warning,
.btn-outline-dark {
  font-weight: bold;
  font-size: 16px;
  line-height: 126.3%;
  letter-spacing: 0.045em;
  border-radius: 50px;
}
.h2 {
  font-size: 30px;
  line-height: 39px;
  font-weight: bold;
  color: #0d2f29;
}
.turquoise {
  color: #34d0b6;
}
.modal-header {
  border-bottom: 0 solid #e9ecef;
}
.close:focus,
.close:hover {
  color: rgba(0, 0, 0, 0.9);
  outline: 0;
  background-color: transparent;
}
.text-warning {
  color: #ffb600;
}

/* Ensure absolute children are positioned inside card body */
.card-body { position: relative; }

/* Apply theme gradient to activity numbers */
.card-body .font-64 {
  background: var(--primary-background);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* Direction-aware positioning for absolute index/icon badge */
/* Float-based positioning for activity numbers so text can wrap around them */
[dir="rtl"] .card-body .position-absolute.d-flex.align-items-top.font-64 {
  position: static !important;
  float: left;
  width: 6rem;
  height: 6rem;
  margin: 0.5rem 1rem 0.5rem 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
[dir="ltr"] .card-body .position-absolute.d-flex.align-items-top.font-64 {
  position: static !important;
  float: right;
  width: 6rem;
  height: 6rem;
  margin: 0.5rem 0.5rem 0.5rem 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Remove fixed padding since content now flows around floated numbers */
[dir="rtl"] .card-body { 
  padding: 1.25rem !important;
}
[dir="ltr"] .card-body { 
  padding: 1.25rem !important;
}

/* Mobile-specific adjustments for floated activity numbers */
@media (max-width: 575.98px) {
  .activity.card .card-body[dir="rtl"],
  [dir="rtl"] .activity.card .card-body,
  [dir="rtl"] .card .card-body { 
    padding: 1rem !important;
  }
  .activity.card .card-body[dir="ltr"],
  [dir="ltr"] .activity.card .card-body,
  [dir="ltr"] .card .card-body { 
    padding: 1rem !important;
  }
  
  /* Smaller floated activity numbers for mobile */
  .activity.card [dir="rtl"] .card-body .position-absolute.d-flex.align-items-top.font-64,
  [dir="rtl"] .activity.card .card-body .position-absolute.d-flex.align-items-top.font-64,
  [dir="rtl"] .card-body .position-absolute.d-flex.align-items-top.font-64 {
    position: static !important;
    float: left !important;
    width: 4.5rem !important;
    height: 4.5rem !important;
    margin: 0.25rem !important;
    font-size: 4rem !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }
  .activity.card [dir="ltr"] .card-body .position-absolute.d-flex.align-items-top.font-64,
  [dir="ltr"] .activity.card .card-body .position-absolute.d-flex.align-items-top.font-64,
  [dir="ltr"] .card-body .position-absolute.d-flex.align-items-top.font-64 {
    position: static !important;
    float: right !important;
    width: 4.5rem !important;
    height: 4.5rem !important;
    margin: 0.25rem !important;
    font-size: 4rem !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }
}
</style>
